import { render, staticRenderFns } from "./CommentsTable.vue?vue&type=template&id=9526bfa4&scoped=true"
import script from "./CommentsTable.vue?vue&type=script&lang=js"
export * from "./CommentsTable.vue?vue&type=script&lang=js"
import style0 from "./CommentsTable.vue?vue&type=style&index=0&id=9526bfa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9526bfa4",
  null
  
)

export default component.exports